import RestService from '@services/RestService';

const codeService = {
  async sendOTP(data = {}) {
    try {
      const res = await new RestService()
        .setPath('/code/send-otp')
        .setHeaders({ 'Content-Type': 'multipart/form-data' })
        .post(data);
      return { data: res?.data, error: null };
    } catch (err) {
      return { error: err?.response?.data || err, data: null };
    }
  },
  async verifyOTP(data = {}) {
    try {
      const res = await new RestService()
        .setPath('/code/verify-otp')
        .setHeaders({ 'Content-Type': 'multipart/form-data' })
        .post(data);
      return { data: res?.data, error: null };
    } catch (err) {
      return { error: err?.response?.data || err, data: null };
    }
  }
};

export default codeService;
